const cobberTypes = [3,7,8,10,11];
const cobberProductIds = [82,83,90,95,96];
const ebikeTypes = [1,4,5,6];

export const hasCobberSettings = (id: number) => {
    // References both type ID and product ID
    return [
        ...cobberTypes,
        ...cobberProductIds
    ].includes(id);
}

export const getImage = (name: string) => {
    return name.includes('Cobber') ? 'Cobber' : name;
};

export const isCartesian = (type: number) => {
    return cobberTypes.includes(type);
}

export const unifiedModes = (type: number) => {
    return cobberTypes.includes(type);
}

export const keepAlive = (type: number) => {
    return cobberTypes.includes(type);
}

export const needsPWMCheck = (type: number) => {
    return ebikeTypes.includes(type);
}

export const compatibleEbike = (type: number) => {
    return ebikeTypes.includes(type);
}